'use strict';
var $ = (window.jQuery = window.$ = require('jquery'));

var Selector = {
  page: '.js-bookingdetail-page',
  resendEmail: '.js-resend-email',
  btnEmail: '.js-booking-email-button',
  resendDialog: '[data-resend-email-dialog]'
};

var openResendDialog = function(message) {
  var dialog = document.querySelector(Selector.resendDialog);
  if (!dialog) return;
  var msgEl = dialog.querySelector('[data-resend-dialog-message]');
  if (msgEl) msgEl.textContent = message;
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
};

var initResendDialog = function() {
  var dialog = document.querySelector(Selector.resendDialog);
  if (!dialog) return;
  var closeBtn = dialog.querySelector('.resend-email-dialog-close-button');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      if (typeof dialog.close === 'function') { dialog.close(); }
      else { dialog.removeAttribute('open'); }
    });
  }
  dialog.addEventListener('click', function(evt) {
    if (evt.target === dialog) {
      if (typeof dialog.close === 'function') { dialog.close(); }
      else { dialog.removeAttribute('open'); }
    }
  });
};

var bindEvent = function() {
  console.log('Booking details online');

  $(Selector.resendEmail).on('submit', function(evt) {
    var $btn = $(Selector.btnEmail);
    evt.preventDefault();
    var $form = $(evt.currentTarget);
    var serialNumber = $form.find('input[name="serial-number"]').val();
    var url = $form.attr('action');

    $.post(url, { serialNumber: serialNumber })
      .done(function(data) {
        openResendDialog(data.message);
        if (data.success) {
          $btn.attr('disabled', 'disabled');
        }
      })
      .fail(function() {
        openResendDialog('Si è verificato un errore. Riprova più tardi.');
      });
  });
};

var initPolicyAccordion = function() {
  var policyDescription = document.getElementById('policyDescription');
  var policyToggleBtn = document.getElementById('policyToggleBtn');
  var policyToggleIcon = document.getElementById('policyToggleIcon');
  var policyToggleBtnText = document.getElementById('policyToggleBtnText');

  if (!policyDescription || !policyToggleBtn || !policyToggleIcon || !policyToggleBtnText) return;
  if (policyToggleBtn.getAttribute('data-policy-accordion-bound') === 'true') return;

  policyToggleBtn.setAttribute('data-policy-accordion-bound', 'true');

  var openLabel = policyToggleBtnText.getAttribute('data-text-open') || 'Chiudi';
  var closedLabel = policyToggleBtnText.getAttribute('data-text-closed') || 'Leggi tutto';

  var togglePolicy = function() {
    // isPolicyExpanded = !isPolicyExpanded;

    var descriptionClasses = policyDescription.className.split(' ');
    var isExpanded = descriptionClasses.indexOf('is-expanded') > -1;

    if (isExpanded) {
      policyDescription.classList.remove('is-expanded');
      policyToggleBtn.setAttribute('aria-expanded', 'false');
      policyToggleBtn.setAttribute('aria-label', 'Expand policy description');
      policyToggleBtnText.textContent = closedLabel;
      policyToggleIcon.classList.remove('is-rotated');
    } else {
      policyDescription.classList.add('is-expanded');
      policyToggleBtn.setAttribute('aria-expanded', 'true');
      policyToggleBtn.setAttribute('aria-label', 'Collapse policy description');
      policyToggleBtnText.textContent = openLabel;
      policyToggleIcon.classList.add('is-rotated');
    }
  };
  policyToggleBtn.addEventListener('click', togglePolicy);

  var releasePolicyHandler = function() {
    policyToggleBtn.removeEventListener('click', togglePolicy);
    window.removeEventListener('pagehide', releasePolicyHandler);
  };

  window.addEventListener('pagehide', releasePolicyHandler);
};

module.exports = function() {
  if ($(Selector.page).length > 0) bindEvent();

  initResendDialog();
  initPolicyAccordion();

  var onceInitPolicyAccordion = function() {
    initPolicyAccordion();
    document.removeEventListener('DOMContentLoaded', onceInitPolicyAccordion);
  };

  document.addEventListener('DOMContentLoaded', onceInitPolicyAccordion);
};
